
<template>
	<div class="App">

		<div class="steps" v-if="['CreateAccount', 'SetupProfile', 'Location'].includes($router.currentRoute.name)">
			<span class="step" :class="{'currentStep': $router.currentRoute.name === 'CreateAccount'}">1</span>
			<span class="stepLine"></span>
			<span class="step" :class="{'currentStep': $router.currentRoute.name === 'SetupProfile'}">2</span>
			<span class="stepLine"></span>
			<span class="step" :class="{'currentStep': $router.currentRoute.name === 'Location'}">3</span>
		</div>

		<div class="whitePaper">
			<h2 class="partnerSignup">{{lang.signup.title}}</h2>
			<LanguageSelect class="languageSelector" />

			<img src="./assets/q_primary.svg" class="Q-logo">
			<img src="./assets/logo-title.svg" class="resqLogo">

			<div class="mainContent">
				<router-view />
			</div>

			<div class="belowWhitePaper">
				<div class="poweredByGoogle"><img src="./assets/powered_by_google_on_non_white_hdpi.png"></div>
				<a class="consumerAppLink littleAndBold" href="https://resq-club.com/app" target="_blank">{{lang.signup.consumerSignup}}

<!--
					<svg class="jss334" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style="width: 1rem; height: 1rem; fill: white; vertical-align: text-bottom;">
						<path fill="none" d="M0 0h24v24H0z"></path>
						<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
					</svg>
-->
				</a>
			</div>
		</div>

		<div ref="elementForGoogleMaps" class="elementForGoogleMaps"></div>
	</div>
</template>

<script>
import lang from './lang'
import { createGoogleScriptElement } from './util/googleApis.js'
import LanguageSelect from './components/LanguageSelect.vue'

export default {
	data() {
		return {
			lang
		}
	},

	mounted() {
		const checkRoute = route => {
			let routeName = route.name
			let state = this.$store.state
			if (
				!routeName ||
				(routeName !== 'Welcome' && (!state.country || !state.name || !state.city))
			) {
				console.warn('invalid route', route)
				this.$router.push('/')
				return
			}
		}
		this.$router.afterEach(checkRoute)
		checkRoute(this.$router.currentRoute)

		document.head.appendChild(createGoogleScriptElement(this.$store))
	},

	components: {
		LanguageSelect
	},
}
</script>

<style lang=stylus src="./styles/global.styl">
</style>

<style lang=stylus scoped>
.App {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}

.steps {
	padding: 30px;
	position: absolute;
	top: 0px;
	width: 100%;
	box-sizing: border-box;

	user-select: none;

	vertical-align: middle;

	.step {
		vertical-align: middle;
		$size = 40px

		box-sizing: border-box

		display: inline-block
		text-decoration: none
		width: $size
		height: $size
		border-radius: $size
		border: 2px solid

		color: rgba(255, 255, 255, .41);

		font-size: 18px
		font-weight: 700

		/* line-height: $size didn't work with brother font*/
		line-height: 35px
	}

	/* finnish text is so damn long */
	@media screen and (max-width: 1200px) {
		display: none;
	}

	.step + .step {
		margin-left: 20px
	}
	.step.currentStep {
		color: white;
	}

	.stepLine {
		vertical-align: middle;
		display: inline-block;
		margin: 5px;
		width: 20px;
		height: 2px;
		background: rgba(255, 255, 255, .41);
	}
/*
	@media screen and (max-width: 700px) {
		visibility: hidden;
	}
	*/
}


.languageSelector {
	position: absolute
	top: -79px;
    right: 0;
}

.whitePaper {
	border-radius: 4px;
	background: white;
	position: relative;
	margin: 0 auto;
	padding: 10px auto;
	max-width: 1300px;
	min-height: calc(100vh - 201px);
	width: 85%;

	margin-bottom: 100px;
	margin-top: 100px;

	@media screen and (max-width: 700px) {
		margin-bottom: 0;
		width: 100%;
		border-radius: 0;
	}
}

.belowWhitePaper {
	width: 100%;
	position: absolute;
	bottom: -63px;

	.poweredByGoogle {
		float: left;
		img {
			width: 150px;
		}
	}
	.consumerAppLink {
		font-size: 14px;
		float: right;
		text-transform: none;
		color: white;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	@media screen and (max-width: 700px) {
		display: none;
	}
}

.mainContent {
	max-width: 600px;
	width: 90%;
	margin: 0 auto;
	padding-bottom: 60px;
	text-align: left;
}

.partnerSignup {
	position: absolute;
    left: 0;
	color: white;
	margin-right: 80px;

	font-weight: 600;
    font-size: 20px;

    transform: translateY(-50%);
    top: -50px;
    text-align: left;
    margin-top: 0;
}

.Q-logo {
	position: absolute;
	bottom: 20px;
	left: -89px;
	width: 320px;

	@media screen and (max-width: 1000px) {
		display: none;
	}
}

.resqLogo {
	margin-top: 46px;
    margin-bottom: 26px;
}

@media screen and (max-width: 700px) {
	.partnerSignup {
		margin-left: 20px;
	}
	.languageSelector {
		margin-right: 20px;
	}
}
</style>
